import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noValueTextExperiment: {
		id: 'issue-field-date-readview-full.date.no-value-text-experiment',
		defaultMessage: 'Add date',
		description: 'Message when a field has no value',
	},
	noValueTextExperimentDueDate: {
		id: 'issue-field-date-readview-full.date.no-value-text-experiment-due-date',
		defaultMessage: 'Add due date',
		description: 'Message when a field has no value',
	},
});
